import * as swcHelpers from '@swc/helpers';
import * as React from 'react';

const MobileWalletContainer = ({ targetId , paymentType , checkout , mobileWalletConfig , children ,  })=>{
    React.useEffect(()=>{
        if (!checkout) {
            return;
        }
        const mountPayment = function() {
            var _ref = swcHelpers.asyncToGenerator(function*() {
                const c = yield checkout;
                const component = c === null || c === void 0 ? void 0 : c.create(paymentType, mobileWalletConfig);
                return component.isAvailable().then(()=>{
                    return component === null || component === void 0 ? void 0 : component.mount(`#${targetId}`);
                }).catch((error)=>{
                    console.error(`Mobile wallet for container with id ${targetId} is not available`, error);
                });
            });
            return function mountPayment() {
                return _ref.apply(this, arguments);
            };
        }();
        const promise = mountPayment();
        return ()=>{
            /**
       * comment this line while testing on local
       * multiple re-render on local cause this component to unmount
       * it works as expected with prod build
       */ promise.then((component)=>{
                return component === null || component === void 0 ? void 0 : component.unmount();
            });
        };
    }, [
        mobileWalletConfig,
        checkout,
        paymentType,
        targetId
    ]);
    if (!checkout) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        id: targetId
    }, children);
};

export { MobileWalletContainer };
//# sourceMappingURL=MobileWalletContainer.js.map
